import { create } from 'zustand';
import type { McpStorageWriteApprovalRequest } from '../../../types/mcpUiControl';

type StorageWriteApprovalState = {
  pendingRequest: McpStorageWriteApprovalRequest | null;
  setPendingRequest: (request: McpStorageWriteApprovalRequest | null) => void;
  approveRequest: (requestId: string) => void;
  denyRequest: (requestId: string) => void;
  /** Main settled this request itself (MCP cancellation, timeout): close without answering. */
  dismissRequest: (requestId: string) => void;
};

const answer = (
  requestId: string,
  approved: boolean,
  get: () => StorageWriteApprovalState,
  set: (next: Pick<StorageWriteApprovalState, 'pendingRequest'>) => void,
): void => {
  if (get().pendingRequest?.requestId !== requestId) return;
  window.electronAPI?.mcpUiControl?.sendStorageWriteApprovalResponse(requestId, approved);
  set({ pendingRequest: null });
};

export const useStorageWriteApprovalStore = create<StorageWriteApprovalState>((set, get) => ({
  pendingRequest: null,
  setPendingRequest: (pendingRequest) => set({ pendingRequest }),
  approveRequest: (requestId) => answer(requestId, true, get, set),
  denyRequest: (requestId) => answer(requestId, false, get, set),
  dismissRequest: (requestId) => {
    if (get().pendingRequest?.requestId === requestId) set({ pendingRequest: null });
  },
}));
